var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"evaluation-viewer-answer"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._l((_vm.results),function(result){return _c('div',{key:result},[_c('evaluation-viewer-answer-item',{attrs:{"type":_vm.question.type,"answers":_vm.question.$answers,"result":result}})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7432e2a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/evaluation-viewer/components/evaluation-viewer-answer.vue
// module id = null
// module chunks = 